var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[_c('base-list-view',{attrs:{"dataSource":_vm.dataSource,"loading":_vm.loading,"headers":_vm.headers,"showDelete":false,"disabledAdd":true,"title":"Отчеты","notShowSelect":"","showFilters":true},on:{"onRefresh":_vm.init,"customHandle":_vm.customHandle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }